// Recovered compiled webpack factory 9150. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { a: () => n });
  let n = (t) => Math.round(1e5 * t) / 1e5;
}
